import { Component, Input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { getUploadPath } from '../../../utility/app.utility';

@Component({
  selector: 'app-logo',
  standalone: true,
  imports: [NgOptimizedImage],
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.scss',
})
export class LogoComponent {
  @Input() logoFileName?: string = '';
  @Input() hStyleClass!: string;
  @Input() variant: 'base' | 'icon' = 'base';
  // Renders the logo at the height given by `hStyleClass` with its natural
  // width (instead of fitting it into a fixed box), so wide logos don't
  // shrink to a thin strip - cap the width via e.g. a `max-w-*` class.
  @Input() autoWidth = false;

  /**
   * The logo's image source: the uploaded commune logo if given, otherwise
   * the bundled atlas logo in the requested variant.
   *
   * @return {string} The image URL.
   */
  get src(): string {
    if (this.logoFileName) return getUploadPath('logo', this.logoFileName);
    return this.variant === 'base'
      ? 'assets/images/logo/base.svg'
      : 'assets/images/logo/icon.svg';
  }
}
